import { Grid, Box, Bones } from '@simplywallst/ui-core';

export const LoadingState = () => {
  return (
    <Box
      minWidth="288px"
      backgroundColor="noir"
      borderRadius="x1"
      data-testid="portfolio-card-loading-state"
    >
      <Grid templateRows="auto 55px 56px" gap="8px">
        <Box paddingXSm="x3" paddingX="x2" paddingY="x2">
          <Grid templateColumns="auto 80px">
            <Grid templateRows="32px auto" gap="34px">
              <Bones minHeight="32px" maxWidth="120px" />
              <Grid
                templateColumns="repeat(auto-fit, minmax(max-content, 70px))"
                templateColumnsSm="repeat(3, max-content)"
                gap="16px"
              >
                <Bones minHeight="24px" minWidth="72px" />
                <Bones minHeight="24px" minWidth="72px" />
                <Bones minHeight="24px" minWidth="72px" />
              </Grid>
            </Grid>
            <Grid justifyContent="center" alignItems="start">
              <Bones minHeight="64px" minWidth="64px" borderRadius="x4" />
            </Grid>
          </Grid>
        </Box>
        <Grid />
        <Box paddingXSm="x3" paddingX="x2" paddingTop="x1" paddingBottom="x2">
          <Grid
            templateColumns="auto 75px"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid templateColumns="repeat(2, 72px)" gap="8px">
              <Bones minHeight="24px" borderRadius="x0_5" />
              <Bones minHeight="24px" borderRadius="x0_5" />
            </Grid>
            <Bones minHeight="24px" minWidth="72px" borderRadius="x0_5" />
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};
